//REF-1
//REF-2
export interface DataDict {
    nodes : { [key: string]: string[]};
    l2image: { [key: string]: string }
    l2audio: { [key: string]: {[key:string]: string} },
    l2visibility: { [key: string]: boolean },
    l2color: { [key: string]: string };
    storageSystem : number;
    homeNodePath: string;
    topSentences:  Array<[string[], number]>;
}

//REF-1
//REF-2
export function isDataDict(obj: any): obj is DataDict{
    return 'nodes' in obj &&
           'l2image' in obj &&
           'l2audio' in obj &&
           'l2visibility' in obj &&
           'l2color' in obj &&
           'storageSystem' in obj &&
           'homeNodePath' in obj &&
           'topSentences' in obj
  }


export  interface Files {
    files: { [key: string]: string }[];
  }


export  interface UpdateClickData {
    date: string;
    userEmail: string | null;
    userUID: string | null;
    isSubscribed: boolean | null;
    checkoutSessionOK: boolean | null;
    subTkn: string | null;
    hasLoggedIn: boolean;  
  }